import { selectArtboardMode } from '@store/reducers/artboard'
import { useSelector } from 'react-redux'

export const useArtboardMode = () => {
  const mode = useSelector(selectArtboardMode)

  const readonly = mode === 'readonly'
  const edit = mode === 'edit'
  const settings = mode === 'settings'
  const activityHistory = mode === 'activity_history'
  const symbolLibrary = mode === 'symbol_library'
  const storage = mode === 'storage'
  const arrows = mode === 'arrows'
  const estimate = mode === 'estimate'
  const readonlyEstimate = mode === 'readonly_estimate'
  const simpleView = mode === 'simple_view'
  const gallery = mode === 'gallery'
  const color = mode === 'color'
  const publish = mode === 'publish'
  const dropzone = mode === 'dropzone'
  const newThread = mode === 'new_thread'
  const seoMode = mode === 'seo_mode'

  return {
    arrows,
    seoMode,
    newThread,
    dropzone,
    publish,
    color,
    gallery,
    simpleView,
    readonlyEstimate,
    estimate,
    storage,
    symbolLibrary,
    activityHistory,
    settings,
    edit,
    readonly,
  }
}
